const testIDs = {
  hub: 'link-ei-hub',
  carbonIntensity: 'link-carbon-intensity',
  billBreakdown: 'link-bill-breakdown',
};

export default testIDs;
